import { render, staticRenderFns } from "./share-document-dialog-component.vue?vue&type=template&id=7ff12e3e&scoped=true"
import script from "./share-document-dialog-component.vue?vue&type=script&lang=ts"
export * from "./share-document-dialog-component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff12e3e",
  null
  
)

export default component.exports